import type { PromozavrRuntimeController } from './runtime-controller';

type PromozavrRuntimeRendererItem = PromozavrRuntimeController['promoRenderers'][number];

type PromozavrRuntimeRenderers = {
    topLinePromoRenderers: PromozavrRuntimeRendererItem[];
    overlayPromoRenderers: PromozavrRuntimeRendererItem[];
};

export function getPromozavrRuntimeRenderers(
    promoRenderers: PromozavrRuntimeController['promoRenderers']
): PromozavrRuntimeRenderers {
    const renderedPromoNames = new Set<string>();
    const topLinePromoRenderers: PromozavrRuntimeRendererItem[] = [];
    const overlayPromoRenderers: PromozavrRuntimeRendererItem[] = [];

    promoRenderers.forEach((promoRenderer) => {
        const promo = promoRenderer.props.currentPromo;
        const promoName = promo?.promo.name;

        if (promoName !== undefined) {
            if (renderedPromoNames.has(promoName)) {
                return;
            }

            renderedPromoNames.add(promoName);
        }

        if (promo?.format !== 'topline') {
            overlayPromoRenderers.push(promoRenderer);
            return;
        }

        topLinePromoRenderers.push(promoRenderer);
    });

    return {
        topLinePromoRenderers,
        overlayPromoRenderers,
    };
}
